import axios from 'axios';
import { useEffect } from "react";
import { TokenApi } from "../api/auth";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { Navigate } from "react-router";
import { useSetRecoilState } from "recoil";
import { Configuration } from "../api/auth";
import { configState } from "../recoil/atoms";
import { useNavigate } from "react-router-dom";
import { BASE_PATH } from "../../src/environment";

type Props = {
  children: JSX.Element;
  authRequirement: boolean;
};

const RestrictedRoute = ({ children, authRequirement }: Props) => {

  const navigate = useNavigate();  
  const [config, setConfig] = useRecoilState(configState);
  const setAccessTokenGlobal = useSetRecoilState(configState);
  const localAccessToken = localStorage.getItem("AccessToken")!;  

  const configToken: Configuration = {
    basePath: BASE_PATH,
    apiKey: localStorage.getItem("RefreshToken") || "",
  };

  const getAccessToken = () => {
    const tokenApi = new TokenApi(configToken);
    return tokenApi.getAccessToken()
      .then((res) => {
        localStorage.setItem("AccessToken", res.data.AccessToken!);
        setAccessTokenGlobal({ ...configState, apiKey: res.data.AccessToken! });
        const loginInfo = JSON.parse(localStorage.getItem("LoginInfo") || "{}");
        loginInfo.AccessToken = res.data.AccessToken;
        localStorage.setItem("LoginInfo", JSON.stringify(loginInfo));
        return Promise.resolve(res.data.AccessToken!);
      })
      .catch((err) => {                
        return Promise.reject(err);
      });
  };

  const handleLogout = async () => {
    localStorage.removeItem("AccessToken");    
    setConfig({ apiKey: "" });
    localStorage.clear();  
    navigate("login");
    toast.info("Session expired. Please login again.");
  };

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(undefined, async (error) => {
      if (
        error.response &&
        error.response.status === 401 &&
        error.response.data?.detail === "token expired"
      ) {        
        try {
          const accessToken = await getAccessToken();          
          const originalRequest = error.config;
          originalRequest.headers["Access-Token"] = accessToken;          
          return axios(originalRequest);
        } catch (err) {
          handleLogout();
        }
      }
      if (
        error.response &&
        error.response.status === 404 &&
        error.response.data?.detail === "Token given has not been found"
      ) {        
        handleLogout();
      }
      return Promise.reject(error);
    });
  
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [handleLogout]);

  let isAuthenticated = !!config.apiKey && !!localAccessToken;
  return isAuthenticated === authRequirement ? (
    children
  ) : authRequirement ? (
    <Navigate to="/login" />
  ) : (
    <Navigate to="/" />
  );
};

export default RestrictedRoute;
